import { render } from "./LocationBeggingModal.vue?vue&type=template&id=aa7b0238&scoped=true&ts=true"
import script from "./LocationBeggingModal.vue?vue&type=script&lang=ts"
export * from "./LocationBeggingModal.vue?vue&type=script&lang=ts"

import "./LocationBeggingModal.vue?vue&type=style&index=0&id=aa7b0238&lang=scss&scoped=true"

import exportComponent from "/builds/knx-core/freightbox/freightbox-monorepo-vue/services/eleos-driver-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa7b0238"]])

export default __exports__